<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent:00em; padding-top:100px;"><strong>You fall</strong> for the words but never what you see. <strong>You try</strong> so hard to find where to be.</p>
<p>Now look at yourself, <strong>you forget</strong> how to feel free.</p>
<p><strong>You pray and beg</strong> on your knees.</p>
<p><strong>You die</strong> and seem to have given up.</p>
<p>I can tell you have been through everything you could do, but is it enough?</p>
<p>I thank you for getting this far, I hope you reach the point where you can walk again without the use of a moving car.</p>
<p>I wanted to let you know you have worth.</p>
<p>Don’t let anyone tell you what to do and what will work.</p>
<p><strong>You believe</strong> in everyone else, but not yourself; why? All you have to do is just pick a side.</p>
<p>It just happened and it’s far from saving.</p>
<p><strong>You know</strong> how to fix these issues; all it takes is waiting.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?35f25e80